import "./OurExpertise.module.css";
import Navigation from "@/reusable_sections/Header";
import Solutions from "./sections/Solutions";
import Results from "./sections/Results";
import Footer from "@/reusable_sections/Footer";
export default function OurExpertisePage() {
  return <div>
      <Navigation />
      <Solutions />
      <Results />
      <Footer />
    </div>;
}